// This file was added to use shadcn ui components
// This file is used to create a custom classnames function that merges tailwind classes with custom classes

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
